import { defineMessages } from 'react-intl';

export default defineMessages({
    mortgageePayMethodMsg: {
        id: "ent.offerdetails.paymentplans.Mortgagee Pay Method Msg",
        defaultMessage: "Your agent setup your offer to be paid by your mortgage company. No additional action is needed to accept this offer."
    },
    viewInstallments: {
        id: 'ent.offerdetails.paymentplans.View Installments',
        defaultMessage: 'View',
    },
    payMinimumAmount: {
        id: 'ent.offerdetails.paymentplans.Pay Minimum Amount',
        defaultMessage: 'Please pay at least the down payment amount.',
    },
    paymentAmountMoreThanPremium: {
        id: 'ent.offerdetails.paymentplans.Payment cannot be more than Total Premium',
       defaultMessage: 'Payment cannot be more than Total Premium.'
   }
});
